// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridContainer: {
      padding: theme.spacing(2),
    },
    searchFormControl: {},
    tableContainer: {
      borderRadius: 0,
      '&::-webkit-scrollbar': {
        height: 6,
        width: 8.5,
      },
      '&::-webkit-scrollbar-thumb': {
        background: 'rgba(170, 184, 194, 0.8);',
        borderRadius: 15,
      },
      overflow: 'auto !important',
      scrollbarWidth: 'thin',
      msOverflowStyle: 'auto',
      width: '100% !important',
    },
    table: {
      width: '100% !important',
      '& th:first-child': {
        borderTopLeftRadius: 15,
      },
      '& th:last-child': {
        borderTopRightRadius: 15,
      },
      '& tr:last-child ': {
        '& td:first-child': { borderBottomLeftRadius: 15 },
        '& td:last-child': { borderBottomRightRadius: 15 },
      },

      '& table': {
        borderRadius: 15,
        marginBottom: 30,
      },
      '& thead': {
        background: '#14171A',
        borderRadius: '15px 15px 0px 0px',
      },
      '& thead th': {
        color: '#fff',
        borderBottom: 'none',
      },
      '& thead tr > *': {
        padding: theme.spacing(1, 2),
      },
      '& tbody tr > *': {
        padding: theme.spacing(0.5, 2),
      },
      '& td': {
        borderBottom: 'none',
      },
      '& tbody tr:nth-of-type(odd) ': {
        background: '#fff',
      },
      '& tbody tr:nth-of-type(even)': {
        background: '#F5F8FA',
      },
      '& tr td:first-child': {
        borderRight: '2px solid #E1E8ED',
      },
      '& tr th:first-child': {
        borderRight: '2px solid #E1E8ED',
      },
    },
    trWithBorder: {
      borderBottom: '2px solid #E1E8ED',
      borderTop: '2px solid #E1E8ED',
    },
    resumeContainer: {
      padding: theme.spacing(1),
    },
    card: {
      background: '#f2f2f2',
      padding: '10px 15px',
      marginBottom: 10,
      borderRadius: 7,
    },
    primaryAmount1: {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
    primaryAmount2: {
      color: '#1CBA27',
      fontWeight: 'bold',
    },
    primaryAmount3: {
      color: '#666',
      fontWeight: 'bold',
    },
    secondaryAmount: {
      marginTop: -5,
      color: '#777',
    },
    resume: {
      display: 'flex',
      alignItems: 'center',
      minWidth: 70,
      height: 42,

      marginRight: 5,
      padding: 7,
      border: '1px solid #14171A',
      borderRadius: 10,
    },
    contentImage: {
      display: 'flex',
      alignItems: 'center',
      maxWidth: 16,
      maxHeight: 16,
      height: '100%',
      marginRight: 5,
    },
    dividerVertical: {
      '&:fist-child': {
        background: '#fff',
      },
      background: '#14171A',
      marginRight: 8,
      marginTop: 1,
    },
    subTiltle: {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 700,
      fontSize: 8,
      color: ' #14171A',
      lineHeight: 1,
    },
    value: {
      fontSize: 12,
      color: ' #14171A',
      lineHeight: 1,
    },
    contentTotalEntry: {
      display: 'grid',
      marginRight: 8,
    },
    content: {
      minWidth: 42,
      height: 42,
      background: ' #F5F8FA',
      borderRadius: 10,
      alignItems: 'center',
      justifyContent: 'center',
    },
    switch: {
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track ': {
        background: '#efefef',
      },
      width: 36,
      height: 20,
      padding: 0,
      margin: '0 10px',
      '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
          transform: 'translateX(16px)',
          color: '#fff',
          '& + .MuiSwitch-track': {
            backgroundColor: '#0094FF',
            opacity: 1,
            border: 0,
          },
          '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.5,
          },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
          color: '#33cf4d',
          border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
          color: theme.palette.grey[100],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.7,
        },
      },
      '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 16,
        height: 16,
      },
      '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#AAB8C2',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
          duration: 500,
        }),
      },
      '& span': {
        color: '#fff',
      },
    },
  }),
);

export default useStyles;
